export default {
    setUser(state, payload){
        state.user=payload;
    },
    setUserInfo(state, payload){
        state.userInfo=payload;
    },
  }